// extracted by mini-css-extract-plugin
module.exports = {"button":"MultiEvents_button__2ONNd","event":"MultiEvents_event__38sLr"};